// import { fetchSysUser } from '../api/sys-user'
import { LoadingTypeEnum, StatusTypeEnum } from '@/utils/enum'
import axios from "axios";

export default {
  filters: {
  },
  data() {
    return {
      LoadingTypeEnum,
      StatusTypeEnum,
      fullLoading: undefined,
      resourceDomain: window.config.resource_domain
    }
  },
  created() {
  },
  mounted: function() {
  },
  computed: {
    /**
     * @returns {[ResourceModel]}
     */
    getResourceList() {
      if (this.$store.getters.resources) {
        // return this.filterVideoGroup === 0 ?
        //   this.$store.getters.resources.filter(x => x.isFilter(this.classCheckList)) :
        //   this.$store.getters.resources.filter(x => x.resourceType === this.filterVideoGroup && x.isFilter(this.classCheckList))
        return this.$store.getters.resources.slice(0, 20)
      } else {
        return []
      }
    }
  },
  methods: {
    openLoading(type = LoadingTypeEnum.DEFAULT) {
      this.fullLoading = this.$loading({
        lock: true,
        text: type,
        background: 'rgba(0, 0, 0, 0.6)',
        customClass: 'custom-loading-class'
      })
    },
    openDownloading(type = LoadingTypeEnum.DOWNLOAD) {
      if (!this.fullLoading) {
        this.fullLoading = this.$loading({
          lock: true,
          text: type,
          background: 'rgba(0, 0, 0, 0.6)',
          customClass: 'custom-loading-class'
        })
      } else {
        this.fullLoading.text = type
      }
    },
    closeLoading() {
      this.fullLoading.close()
    },
    getResourceUrl(path) {
      return `${this.resourceDomain}/${path}`
    },
    goDownloadResource(url) {
      this.openDownloading()
      const _this = this
      const fileUrl = this.getResourceUrl(url)
      const fileSplit = url.split('/')
      const fileName = fileSplit[fileSplit.length - 1]
      axios({
        url: fileUrl,
        method: "GET",
        responseType: "blob",
        onDownloadProgress: (progressEvent) => {
          let percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          _this.openDownloading(`${percentCompleted}%`)
        },
      }).then((response) => {
        const url = window.URL.createObjectURL(response.data);
        // const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => {
          this.closeLoading()
        }, 500)
      });
    }
  }
}
